import React, { useEffect, useState } from 'react';
import { useBreakpoint } from '@next-common/breakpoint';
import { Drawer } from '@next-common/mui';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AvailableContent, UnavailableContent } from './components';
import { EconomicOperatorContextProvider, useEconomicOperatorContext } from './contexts';
const EconomicOperatorContainer = ({ title, isAvailable, isEshop }) => {
    const { isVisible, toggleVisible } = useEconomicOperatorContext();
    const [open, setOpen] = useState(false);
    const { breakpoint } = useBreakpoint();
    const backgroundImage = `https://fr.shopping.rakuten.com/visuels/0_next-common/eshop-header/${breakpoint === 'tablet' || breakpoint === 'phone' ? 'xs' : 'md'}-operator-economic.png`;
    const toggleDrawer = () => {
        setOpen(!open);
    };
    const handleEventFetching = (event) => {
        if (event.detail) {
            // TODO: fetching seller legal data and toggle visible
            // TODO: should set isEshop data on state(or on context)
            toggleVisible();
        }
    };
    useEffect(() => {
        document.addEventListener('ECONOMIC-OPERATOR-DRAWER', handleEventFetching);
        return () => {
            document.removeEventListener('ECONOMIC-OPERATOR-DRAWER', handleEventFetching);
        };
    }, []);
    return (React.createElement(Box, null,
        React.createElement(Typography, { component: 'p', onClick: toggleDrawer, style: { cursor: 'pointer' } }, title),
        React.createElement(Drawer, { open: open, title: 'Détails de conformité du produit', titlePosition: "start", onClose: () => setOpen(false), iconHeight: "24px", iconWidth: "24px", content: isVisible ? (React.createElement(Stack, { padding: "16px" },
                React.createElement(Stack, { gap: 2 },
                    React.createElement(Box, { sx: {
                            width: '100%',
                            height: '120px',
                            borderRadius: '8px',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundImage: `url(${backgroundImage})`,
                        } }),
                    isAvailable ? React.createElement(AvailableContent, { data: [] }) : React.createElement(UnavailableContent, { isEshop: isEshop })))) : undefined })));
};
export const EconomicOperator = (props) => {
    return (React.createElement(EconomicOperatorContextProvider, null,
        React.createElement(EconomicOperatorContainer, Object.assign({}, props))));
};
